export default "__VITE_ASSET__Mr9_gGs8__"